import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Col as ColAnt, Form, Grid, Input, Row } from 'antd';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import InputMask from '../../components/input-mask';
import { prefijos3Digitos, validarCaracterEspecial } from '../../utils';

const { useBreakpoint } = Grid;

// eslint-disable-next-line import/prefer-default-export
export const useInvolucradosList = (title, type, name) => {
  const screens = useBreakpoint();
  const label = title.slice(0, -1);

  const Col = !screens.md
    ? ColAnt
    : styled((props) => (
        <ColAnt {...props} style={{ ...props.style, padding: 16 }} />
      ))`
        border-right: 1px solid #f0f0f0;
        border-bottom: 1px solid #f0f0f0;
        transition: background 0.3s;
        padding: 16px;
        &:first-child {
          border-left: 1px solid #f0f0f0;
        }
        &:hover {
          background: #fafafa;
        }
      `;

  const InvolucradosForm = ({ field }) => {
    return (
      <>
        {type === 1 && (
          <>
            <Col
              xs={24}
              md={5}
              align="start"
              style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
            >
              <Form.Item
                {...field}
                name={[field.name, 'nombres']}
                label={screens.md ? '' : 'Nombre'}
                fieldKey={[field.fieldKey, 'nombres']}
                rules={[{ required: true, message: 'Requerido' }]}
                onKeyPress={(e) => {
                  const pressedKey = String.fromCharCode(
                    !e.charCode ? e.which : e.charCode
                  );
                  validarCaracterEspecial(e, pressedKey);
                }}
                onPaste={(e) => {
                  const pastedText = e.clipboardData.getData('text');
                  validarCaracterEspecial(e, pastedText);
                }}
              >
                <Input placeholder="Nombre y Apellido" />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={5}
              align="start"
              style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
            >
              <Form.Item
                {...field}
                name={[field.name, 'celular']}
                label={screens.md ? '' : 'Celular'}
                fieldKey={[field.fieldKey, 'celular']}
                rules={[
                  {
                    pattern: `^\\((${prefijos3Digitos.join(
                      '|'
                    )})\\) [0-9]{3}-[0-9]{3}$`,
                    message: 'Número no válido'
                  }
                ]}
              >
                <InputMask
                  mask="(999) 999-999"
                  placeholder="(___) ___-___"
                  addonBefore="+595"
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={8}
              align="start"
              style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
            >
              <Form.Item
                {...field}
                name={[field.name, 'datos_adicionales']}
                label={screens.md ? '' : 'Descripción'}
                fieldKey={[field.fieldKey, 'datos_adicionales']}
                onKeyPress={(e) => {
                  const pressedKey = String.fromCharCode(
                    !e.charCode ? e.which : e.charCode
                  );
                  validarCaracterEspecial(e, pressedKey);
                }}
                onPaste={(e) => {
                  const pastedText = e.clipboardData.getData('text');
                  validarCaracterEspecial(e, pastedText);
                }}
              >
                <Input placeholder="Marca, modelo, año..." />
              </Form.Item>
            </Col>
            {/* <Col
              xs={24}
              md={3}
              align="start"
              style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
            >
              <Form.Item
                {...field}
                name={[field.name, 'modelo']}
                label={screens.md ? '' : 'Modelo'}
                fieldKey={[field.fieldKey, 'modelo']}
                onKeyPress={(e) => {
                  const pressedKey = String.fromCharCode(
                    !e.charCode ? e.which : e.charCode
                  );
                  validarCaracterEspecial(e, pressedKey);
                }}
                onPaste={(e) => {
                  const pastedText = e.clipboardData.getData('text');
                  validarCaracterEspecial(e, pastedText);
                }}
              >
                <Input placeholder="Modelo" />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={3}
              align="start"
              style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
            >
              <Form.Item
                {...field}
                name={[field.name, 'submodelo']}
                label={screens.md ? '' : 'Submodelo'}
                fieldKey={[field.fieldKey, 'submodelo']}
                onKeyPress={(e) => {
                  const pressedKey = String.fromCharCode(
                    !e.charCode ? e.which : e.charCode
                  );
                  validarCaracterEspecial(e, pressedKey);
                }}
                onPaste={(e) => {
                  const pastedText = e.clipboardData.getData('text');
                  validarCaracterEspecial(e, pastedText);
                }}
              >
                <Input placeholder="Submodelo" />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={2}
              align="start"
              style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
            >
              <Form.Item
                {...field}
                name={[field.name, 'anio']}
                label={screens.md ? '' : 'Anio'}
                fieldKey={[field.fieldKey, 'anio']}
                onKeyPress={(e) => {
                  const pressedKey = String.fromCharCode(
                    !e.charCode ? e.which : e.charCode
                  );
                  validarCaracterEspecial(e, pressedKey);
                }}
                onPaste={(e) => {
                  const pastedText = e.clipboardData.getData('text');
                  validarCaracterEspecial(e, pastedText);
                }}
              >
                <Input placeholder="Año" />
              </Form.Item>
              </Col> */}
            <Col
              xs={24}
              md={3}
              align="start"
              style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
            >
              <Form.Item
                {...field}
                name={[field.name, 'chapa']}
                label={screens.md ? '' : 'Chapa'}
                fieldKey={[field.fieldKey, 'chapa']}
                onKeyPress={(e) => {
                  const pressedKey = String.fromCharCode(
                    !e.charCode ? e.which : e.charCode
                  );
                  validarCaracterEspecial(e, pressedKey);
                }}
                onPaste={(e) => {
                  const pastedText = e.clipboardData.getData('text');
                  validarCaracterEspecial(e, pastedText);
                }}
              >
                <Input placeholder="Chapa" />
              </Form.Item>
            </Col>
          </>
        )}
        {type !== 1 && (
          <>
            <Col
              xs={24}
              md={15}
              align="start"
              style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
            >
              <Form.Item
                {...field}
                name={[field.name, 'nombres']}
                label={screens.md ? '' : 'Nombre'}
                fieldKey={[field.fieldKey, 'nombres']}
                rules={[{ required: true, message: 'Requerido' }]}
                onKeyPress={(e) => {
                  const pressedKey = String.fromCharCode(
                    !e.charCode ? e.which : e.charCode
                  );
                  validarCaracterEspecial(e, pressedKey);
                }}
                onPaste={(e) => {
                  const pastedText = e.clipboardData.getData('text');
                  validarCaracterEspecial(e, pastedText);
                }}
              >
                <Input placeholder="Nombre y Apellido" />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={6}
              align="start"
              style={screens.md ? { borderLeft: '1px solid #f0f0f0' } : null}
            >
              <Form.Item
                {...field}
                name={[field.name, 'celular']}
                label={screens.md ? '' : 'Celular'}
                fieldKey={[field.fieldKey, 'celular']}
                rules={[
                  {
                    pattern: `^\\((${prefijos3Digitos.join(
                      '|'
                    )})\\) [0-9]{3}-[0-9]{3}$`,
                    message: 'Número no válido'
                  }
                ]}
              >
                <InputMask
                  mask="(999) 999-999"
                  placeholder="(___) ___-___"
                  addonBefore="+595"
                />
              </Form.Item>
            </Col>
          </>
        )}
      </>
    );
  };

  const headerStyle = {
    fontWeight: 500,
    textAlign: 'left',
    background: '#fafafa',
    borderTop: '1px solid #f0f0f0',
    borderBottom: '1px solid #f0f0f0',
    borderRight: '1px solid #f0f0f0'
  };

  const List = () => (
    <>
      <Form.List name={name}>
        {(fields, { add, remove }) => {
          return (
            <>
              {screens.md && (
                <Row gutter={[16, 0]} style={{ maxWidth: '1800px' }}>
                  {type === 1 && (
                    <>
                      {' '}
                      <Col xs={24} md={5} align="start" style={headerStyle}>
                        Nombre y apellido
                      </Col>
                      <Col xs={16} md={5} align="start" style={headerStyle}>
                        Nro de Contacto
                      </Col>
                      <Col xs={8} md={8} align="start" style={headerStyle}>
                        Descripción
                      </Col>
                      {/*                      <Col xs={8} md={3} align="start" style={headerStyle}>
                        Modelo
                      </Col>
                      <Col xs={8} md={3} align="start" style={headerStyle}>
                        Submodelo
                      </Col>
                      <Col xs={8} md={2} align="start" style={headerStyle}>
                        Año
                  </Col> */}
                      <Col xs={8} md={3} align="start" style={headerStyle}>
                        Chapa
                      </Col>
                    </>
                  )}
                  {type !== 1 && (
                    <>
                      {' '}
                      <Col xs={24} md={15} align="start" style={headerStyle}>
                        Nombre y apellido
                      </Col>
                      <Col xs={16} md={6} align="start" style={headerStyle}>
                        Nro de Contacto
                      </Col>
                    </>
                  )}
                  <Col xs={24} md={3} align="start" style={headerStyle} />
                  {fields.map((field) => (
                    <Fragment key={field.key}>
                      <InvolucradosForm field={field} />
                      <Col xs={24} md={3} align="start">
                        <Button
                          type="dashed"
                          danger
                          onClick={() => {
                            remove(field.name);
                          }}
                        >
                          Borrar
                        </Button>
                      </Col>
                    </Fragment>
                  ))}
                  <ColAnt xs={24}>
                    <Form.Item style={{ paddingTop: '20px' }}>
                      <Button
                        type="primary"
                        shape="round"
                        onClick={() => {
                          add();
                        }}
                      >
                        <PlusOutlined /> Agregar {label} adicional
                      </Button>
                    </Form.Item>
                  </ColAnt>
                </Row>
              )}
              {screens.md === false && (
                <>
                  {fields.map((field) => (
                    <Card
                      key={field.key}
                      actions={[
                        <Button
                          type="dashed"
                          danger
                          onClick={() => {
                            remove(field.name);
                          }}
                        >
                          Borrar
                        </Button>
                      ]}
                    >
                      <Row gutter={[8, 4]} style={{ maxWidth: '1800px' }}>
                        <InvolucradosForm field={field} />
                      </Row>
                    </Card>
                  ))}
                  <Col xs={24} style={{ paddingTop: 20 }}>
                    <Form.Item>
                      <Button
                        type="primary"
                        shape="round"
                        onClick={() => {
                          add();
                        }}
                      >
                        <PlusOutlined /> Agregar {label} adicional
                      </Button>
                    </Form.Item>
                  </Col>
                </>
              )}
            </>
          );
        }}
      </Form.List>
    </>
  );

  return [List];
};
